import React from 'react';
import { Empty } from 'antd';

const RuntimeEmptyState = ({
  description = 'Nenhum dado operacional encontrado para o filtro atual.',
}) => {
  return <Empty description={description} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
};

export default RuntimeEmptyState;